import AppletSubgroups from "../../../models/applet/applet-subgroup.entity";
import InspectionStepLocalDB from "../../../models/indexedDB/inspection-step-local-db.entity";
import appletSubgroupService from "./applet-subgroup.service";

class InspectionProgressService {
  public getProfileSteps(appletProfileId: string): AppletSubgroups[] {
    if (!appletProfileId) return [];

    try {
      const appletSubgroupType = appletSubgroupService.getAppleSubgroupList(appletProfileId);
      const profile = appletSubgroupType.profiles
        .find((item) => item.id === appletProfileId);

      return profile?.appletSubgroups || [];
    } catch {
      return [];
    }
  }

  public getMissingSteps(inspectionSteps: InspectionStepLocalDB[]): AppletSubgroups[] {
    if (!inspectionSteps?.length) return [];

    const profileSteps = this.getProfileSteps(inspectionSteps[0].appletProfileId);
    const capturedIds = new Set(inspectionSteps.map((step) => step.appletSubgroupId));

    return profileSteps.filter((step) => !capturedIds.has(step.id));
  }

  public isIncomplete(inspectionSteps: InspectionStepLocalDB[]): boolean {
    return this.getMissingSteps(inspectionSteps).length > 0;
  }
}

// eslint-disable-next-line import/no-anonymous-default-export
export default new InspectionProgressService();
